import { useEffect } from 'react';
import styles from './ViewFieldsTemplate.module.css';
import { useForm, FormProvider } from 'react-hook-form';
import { Button } from '@mui/material';
import Field from 'features/dynamicForm/components/Field/Field';
import { fieldsTemplateType } from 'features/dynamicForm/types';

export default function ViewFieldsTemplate({ fieldsTemplate }) {
    const methods = useForm({ shouldUnregister: true });

    const onSubmit = (data) => {
        console.log('Submit data', data);
        alert(JSON.stringify(data, null, 2));
    };

    useEffect(() => {
        methods.reset();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldsTemplate]);

    return (
        <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)} noValidate>
                <section className={styles['section']}>
                    <div className={styles['inputs']}>
                        {fieldsTemplate?.form?.map((field) => {
                            return <Field key={field.key} field={field} />;
                        })}
                    </div>
                </section>
                <Button variant="contained" color="success" size="small" type="submit">
                    submit
                </Button>
            </form>
        </FormProvider>
    );
}

ViewFieldsTemplate.propTypes = {
    fieldsTemplate: fieldsTemplateType,
};
